import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useWidgetActions, useWidgetState} from '../../../../../../hooks/state-provider'
import {getDayMonthText, getEventsForDay, getSelectedDate} from '../../../../../../selectors/calendar-layout'
import {PopupHeader} from '../header'
import {MonthlyCalendarEventListItem} from './event-list-item'
import s from './monthly-calendar-event-list.scss'

export const MonthlyCalendarEventList = () => {
  const {t} = useTranslation()

  const {closeMonthlyCalendarPopup, openMonthlyCalendarEvent} = useWidgetActions()

  const selectedDate = useWidgetState(getSelectedDate)
  const events = useWidgetState(state => getEventsForDay(state, selectedDate))
  const dateText = useWidgetState(state => getDayMonthText(state, selectedDate))

  const handleKeyPress = (domEvent: React.KeyboardEvent, eventId: string) => {
    if (domEvent.key === 'Enter') {
      openMonthlyCalendarEvent({eventId, selectedDate})
    }
  }

  return (
    <div className={s.container} data-hook="calendar-event-list">
      <PopupHeader eventList text={dateText} onClose={() => closeMonthlyCalendarPopup()} t={t} />
      <ul className={s.list}>
        {events.map(event => (
          <MonthlyCalendarEventListItem
            key={event.id}
            onClick={() => openMonthlyCalendarEvent({eventId: event.id, selectedDate})}
            onKeyPress={domEvent => handleKeyPress(domEvent, event.id)}
            event={event}
            selectedDate={selectedDate}
          />
        ))}
      </ul>
    </div>
  )
}
